import { render } from "./loginView.vue?vue&type=template&id=187e95ac"
import script from "./loginView.vue?vue&type=script&lang=js"
export * from "./loginView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__